import { render, staticRenderFns } from "./CollectionFilterControl.vue?vue&type=template&id=18624bae"
import script from "./CollectionFilterControl.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControl.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports